import React, { ReactNode } from 'react';
import { RFC } from '../types/generalTypes';

const SplashPageContainer: RFC<{ children: ReactNode }> = ({ children }) => (
    <div className="lg:w-full md:w-full sm:w-full xs:w-4/5 mt-20 mx-auto max-w-md">{children}</div>
);

export default SplashPageContainer;
